export const environment = {

  // HOMOLOGAÇÃO
  api: 'https://homolog.viarapidaempresa.sp.gov.br/integrador-api',
  apiLogin: 'https://homolog.viarapidaempresa.sp.gov.br/loginApi',

  mockToken: false,
  chaveToken: '',
  baseURL: 'https://homolog.viarapidaempresa.sp.gov.br',

  apiMaps: 'AIzaSyB3N1B_7tMUe8CO-nvybtQQ-0mkEUEIdhU',
  apiAdmin: 'https://homolog.viarapidaempresa.sp.gov.br/modulo-adm-api-sustentacao',
  production: false,

  linkViabilidade: 'https://homologacao.vre.jucesp.sp.gov.br/IntegradorPaulista/Seguranca/TokenAuth/?id=viabilidade|',
  linkLicenciamento: 'https://homologacao.vre.jucesp.sp.gov.br/IntegradorPaulista/Seguranca/TokenAuth/?id=licenciamento|',
  linkInscricaoMunicipal: 'https://homologacao.vre.jucesp.sp.gov.br/inscricaomunicipal20.services/spa/connect?resource=protocolo&login=',
  linkVRE: 'https://homologacao.vre.jucesp.sp.gov.br/vre/seguranca/logincert.aspx?token=',
  linkRegistro: 'https://homolog.viarapidaempresa.sp.gov.br/vre-digital-sustentacao/?tkLogin=',
  linkBalcaoUnico: 'https://jucespcoletaunica--tst3.custhelp.com/app/abertura_empresa?token=',
  linkCartorio: 'https://homologpj.irtdpjsp.com.br/registro?tkLogin=',
  linkOab: 'https://deviis02.oabsp.org.br/asp/dotnet/LoginSite/AcessoRestrito/gateway.aspx?op=160',
  //links modal DBE
  linkDBEMatriz: 'https://hom-redesimservicos.np.estaleiro.serpro.gov.br/coletor-nacional/opcoes/inscricao-matriz',
  linkDBEFilial: 'https://hom-redesimservicos.np.estaleiro.serpro.gov.br/coletor-nacional/opcoes/inscricao-filial',
  linkDBEAlteracaoPj: 'https://hom-redesimservicos.np.estaleiro.serpro.gov.br/coletor-nacional/opcoes/alteracao',
  linkDBEBaixaPj: 'https://hom-redesimservicos.np.estaleiro.serpro.gov.br/coletor-nacional/opcoes/baixa',
  linkAndamentoCNPJ: 'https://hom-redesimservicos.np.estaleiro.serpro.gov.br/consultapedido/',
  linkCPFBloqueado: 'https://jucespcoletaunica--tst3.custhelp.com/app/bloqueioCpf/bloqueio_cpf?token=',
  linkMapaMunicipios: 'https://homolog.viarapidaempresa.sp.gov.br/mapa-municipios-conveniados'
};
